import React from "react";
import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { ProjectManagementListProps } from "./ProjectManagement.types";

const ProjectManagement = lazyWithRetry(() => import("./ProjectManagement"));

export default (props: ProjectManagementListProps) => (
  <Page>
    <ProjectManagement {...props} />
  </Page>
);
